import { Logger } from '@/utils/logger';

export async function forEachAsync<T>(
    asyncIterable: AsyncIterable<T>,
    callback: (result: T) => void,
    abortController: AbortController,
    stopMsg?: string
) {
    try {
        for await (const result of asyncIterable) {
            if (abortController.signal.aborted) break;
            callback(result);
        }
    } catch (err: any) {
        if (err.name === 'AbortError') {
            Logger({ title: `${stopMsg}: Stream Aborted`, callback: () => {
                console.log(err);
            } });
        } else {
            Logger({ title: `${stopMsg}: Stream Aborted`, callback: () => {
                console.log(err);
            } });
            // throw err;
        }
    }
}

export async function asyncList<T>(asyncIterable: AsyncIterable<T>, format?: (event: T) => any) {
    const resList: any[] = [];
    for await (const val of asyncIterable) resList.push(format ? format(val) : val);
    return resList;
}
